import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import $ from 'jquery';
import URL from '../../flux/path';
import axios from 'axios';

import logo from '../../assets/img/logo.svg';
export default class Footer extends Component {
	constructor(props){
		super(props);
		this.state = { footer: [] }
	}
	componentDidMount(){
		const cookies = new Cookies();
		var $date = 3600 * 1000 * 24 * 365 * 10;
		if( cookies.get( 'mundon_cookie_privacy' ) === undefined ){
			$('#cookie-notice').slideDown(500);
		}
		this.getFooterMenu();
	}
	getFooterMenu(){
		axios.get(URL.menuFooter)
		.then( res => {
			this.setState({ footer: res.data.items })
		});
	}
	componentWillMount(){
		$(document).on('click', '.cookie-btn',function(e){
			const cookies = new Cookies();
			var $date = 3600 * 1000 * 24 * 365 * 10;
			cookies.set( 'mundon_cookie_privacy', 'read', { path: '/', maxAge: $date } );
			$('#cookie-notice').slideUp(600);
			e.preventDefault();
		})
	}
	render(){
		console.log( this.state.footer );
		let TemasMenu = null;
		let ItemsMenu = [];
		if( this.state.footer != '' ){
			this.state.footer.map((item, key) =>{
				if( item.children != undefined ){
					TemasMenu = (
						<div>
							<li className="menu-item">
								<a href="#">{item.title}</a>
									<ul className="sub-menu">
								{
									item.children.map((child, key)=>{
										<li className="menu-item">
											<a href={ 'https://decojovem.pt/iniciativa/mundon/temas' + child.title }>
												{child.title}
											</a>
										</li>
									})
								}
									</ul>
							</li>
						</div>
					)
				} else if( item.children == undefined ) {
					ItemsMenu.push(
						<div>
								<li className="menu-item">
									<a href={item.object_slug}>
										{item.title}
									</a>
								</li>
						</div>
					)
				}
			})
		}
		return(
			<div>
				<footer role="contentinfo" className="main-footer" id="main-footer">
					<div className="container-fluid">
						<div className="row">
							<div className="col-18 col-lg-6">
								<a href="https://www.decojovem.pt/iniciativa/mundon" title="MundOn" className="footer-logo">
									<img src={logo} alt="Mundo On" />
								</a>
							</div>
							<div className="col-18 col-lg-6">
								<div className="row">
									<div className="col">
										<ul className="menu-footer-geral">
											{ItemsMenu}
										</ul>
									</div>
									<div className="col">
										<ul className="menu-footer-temas">
											{TemasMenu}
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col text-right">
								<ul className="list-social">
									<li><a href="#" className="icon-facebook"></a></li>
									<li><a href="#" className="icon-youtube"></a></li>
									<li><a href="#" className="icon-instagram"></a></li>
								</ul>
							</div>
						</div>
						<div className="row">
							<div className="col text-right active-signature">
								©2017 DecoJovem. Todos os direitos reservados.<br/>um site <a href="http://www.activemedia.pt" target="_blank">Active Media</a>
							</div>
						</div>
					</div>
				</footer>
				<div className="cookies text-center" id="cookie-notice" style={{display:'none'}} >
					O nosso site utiliza cookies para lhe oferecer uma melhor experiência. Consulte a nossa<a href="https://decojovem.pt/politica-de-cookies/" className="cookie-policy">Política de Cookies</a>. <a href="#" className="btn btn-primary cookie-btn">OK</a>
					<a href="#" className="fa fa-times cookie-btn"></a>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/footer/footer.js